import type { HomeEconomy } from "@/home/economy";
import {
  allowanceCapForReadiness,
  sumSpawnCountsByMonster,
} from "@/dungeon/dungeon-monster-vault";
import type { TowerFloorSpawnRow } from "@/tower/tower-floor-config";

export type DungeonFloorReadinessSpawn = Pick<TowerFloorSpawnRow, "monsterId" | "count">;

export function dungeonFloorMissingRequirements(params: {
  spawns: DungeonFloorReadinessSpawn[];
  economy: HomeEconomy;
  savedSpawnsOnFloor: TowerFloorSpawnRow[];
  scenePlacementCount: number;
  monsterName?: (monsterId: string) => string;
}): string[] {
  const label = params.monsterName ?? ((id) => id);
  const missing: string[] = [];
  const rows = params.spawns.filter((row) => row.monsterId);

  if (rows.length === 0) {
    missing.push("มอนสเตอร์ในด่าน — กด + แถว แล้วเลือกมอนสเตอร์");
    return missing;
  }

  const totals = sumSpawnCountsByMonster(rows);
  for (const [monsterId, total] of Object.entries(totals)) {
    const cap = allowanceCapForReadiness(
      params.economy,
      params.savedSpawnsOnFloor,
      monsterId,
    );
    const name = label(monsterId);
    if (cap <= 0) {
      missing.push(`ซื้อมอนสเตอร์ «${name}» จากร้าน (แท็บมอนสเตอร์)`);
    } else if (total > cap) {
      missing.push(`จำนวน «${name}» เกินคลัง (${total}/${cap})`);
    } else if (total < 1) {
      missing.push(`ตั้งจำนวน «${name}» อย่างน้อย 1`);
    }
  }

  if (params.scenePlacementCount === 0) {
    missing.push("วางชิ้นฉากบนกริดอย่างน้อย 1 ชิ้น");
  }

  return missing;
}

export function dungeonFloorCanEnable(
  params: Parameters<typeof dungeonFloorMissingRequirements>[0],
): boolean {
  return dungeonFloorMissingRequirements(params).length === 0;
}

export function dungeonFloorEnableBlockedMessage(missing: string[]): string {
  if (missing.length === 0) return "";
  return `ยังเปิดด่านไม่ได้ — ขาด: ${missing.join(" · ")}`;
}
